<prism-dialog [visible]="true" cancelButton="" confirmButton="" *transloco="let t; prefix: 'scConfirmDialog'">
	@if (data.title) {
		<span slot="dialog-title" class="sh-confirm-dialog-title" data-testid="sh-confirm-dialog-title">
			@if (data.showIcon) {
				<prism-icon
					class="sh-warning-icon"
					[class.sh-info-icon]="data.showIcon === showIcon.Info"
					[icon]="data.showIcon === showIcon.Warning ? 'sh-warning-outline' : 'mdo-info'"
				/>
			}
			<span [innerHtml]="data.title"></span>
		</span>
	}

	<div class="sh-content-body">
		@if (data.body) {
			@for (line of data.body; track $index) {
				<span>
					@if (isTextObject(line)) {
						<prism-icon
							class="sh-body-icon"
							[class.sh-info-icon]="data.showIcon === showIcon.Info"
							[icon]="line.icon"
						/>
						<span class="mat-body-2" [innerHtml]="line.text"></span>
					} @else {
						<span class="mat-body-2" [innerHtml]="line"></span>
					}
				</span>
			}
		}

		@if (data.doNotShowDialogId) {
			<prism-checkbox
				id="sh-confirm-dialog-do-not-show"
				data-testid="sh-confirm-dialog-do-not-show"
				[checked]="doNotShowDialog"
				(valueChange)="toggleDoNotShowDialog($event.detail)"
			>
				{{ t('no-show-dialog-again') }}
			</prism-checkbox>
		}
	</div>

	<div slot="dialog-footer-buttons" class="footer">
		<prism-button
			id="sh-confirm-dialog-cancel-button"
			[attr.autofocus]="data.autofocus === 'cancelButton' ? '' : null"
			(click)="closeDialog({ confirmed: false, doNotShowDialog: false })"
		>
			{{ data.cancelLabel }}
		</prism-button>

		<prism-button
			id="sh-confirm-dialog-confirm-button"
			[variant]="data.confirmVariant ?? 'bright'"
			[disabled]="data.confirmDisabled"
			[attr.autofocus]="data.autofocus === 'confirmButton' ? '' : null"
			(click)="closeDialog({ confirmed: true, doNotShowDialog })"
		>
			{{ data.confirmLabel }}
		</prism-button>
	</div>
</prism-dialog>
